import { IntegrationType } from './../models/enums'
import { IframeHeight } from '../models/types'

export const getWindowDimensions = () => {
  if (window === undefined) return { width: 0, height: 0 }

  const { innerWidth: width, innerHeight: height } = window
  return {
    width,
    height,
  }
}

export const getElementDimensions = (element: HTMLElement | undefined) => {
  if (element === undefined) return { width: 0, height: 0 }

  const { offsetWidth: width, offsetHeight: height } = element
  return {
    width,
    height,
  }
}

export const getWidgetDimensions = (
  iframeHeight: IframeHeight,
  integrationType: IntegrationType | null | undefined
) => {
  const defaultDimensions = {
    width: '100%',
  }

  if (typeof iframeHeight === 'number') {
    return {
      height: `${iframeHeight}px`,
      ...defaultDimensions,
    }
  }

  if (typeof iframeHeight === 'string') {
    return {
      height: iframeHeight,
      ...defaultDimensions,
    }
  }

  if (integrationType === IntegrationType.PatientHub) {
    return {
      height: 'auto',
      ...defaultDimensions,
    }
  }

  return {
    height: '100dvh',
    ...defaultDimensions,
  }
}
